import { Box, Button, Divider, Grid, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import StatusCard from "./components/status/status";
import Note from "./components/note/note";
import BugAttachment from "./components/bugs/bugImageAttachment";
import BugAttachmentPdf from "./components/bugs/attachmentPdf";
import { TicketChat } from "./components/ticketChat/ticketChat";

export default function TicketDetail() {
  const [opened, setOpened] = useState(false);
  return (
    <Box p="lg">
      <Group position="apart" mb="md">
        <Title order={2}>TicketDetail</Title>
      </Group>
      <Divider mb="md" />
      <Grid>
        <Grid.Col span={8}>
          {" "}
          <StatusCard />
          <Note />
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: 10,
              marginTop: "10px",
              //   justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <BugAttachment />
            </div>
            <div style={{ width: "50%" }}>
              <BugAttachmentPdf />
            </div>
          </div>
        </Grid.Col>
        {/* <Grid.Col span={4}>2</Grid.Col> */}
        <Grid.Col span={4}>
          {" "}
          <TicketChat />
        </Grid.Col>
      </Grid>
    </Box>
  );
}
